module.exports = __webpack_public_path__ + "img/facebook-color.ce65adeb.svg";